module.exports = __webpack_public_path__ + "assets/img/18.7d3dd231.png";